// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.emd-form-box__image svg,\n.emd-form-box__image img {\n  height: 24px;\n  width: 98px;\n}\n.emd-form-box__header {\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
